<ng-container *ngIf="inline">
  <span [title]="getSafeFullText()">
    {{ fitContent }}

    <span *ngIf="contentSuffix" class="text-right text-primary clickable" (click)="openMoreInfoDialog()">
      {{ contentSuffix }}
    </span>
  </span>
</ng-container>

<ng-container *ngIf="!inline">
  {{ fitContent }}{{ contentSuffix }}

  <div *ngIf="shouldShowNonInlineDecor()" class="text-right text-primary clickable" (click)="openMoreInfoDialog()">
    More
  </div>
</ng-container>
